import { useCallback } from 'react';
import { useAbility } from '@casl/react';
import { AbilityContext } from 'app/atoms';
import { useUserInfo } from './useUserInfo';
import { Permissions } from 'app/modules/Auth/types';

export const usePermissions = () => {
  const ability = useAbility(AbilityContext);
  const { data: userInfo } = useUserInfo();

  const hasVisibility = useCallback(
    (subject: string): boolean => {
      const subjectPermissions = userInfo?.permissions?.[subject as keyof Permissions];
      return subjectPermissions?.isVisible ?? false;
    },
    [ability, userInfo],
  );

  const can = useCallback(
    (action: string, subject: string): boolean => {
      return ability.can(action, subject);
    },
    [ability],
  );

  return {
    hasVisibility,
    can,
  };
};
